class SwiperSlide extends HTMLElement {
  constructor() {
    super();
    this.mainSwiper = null;
    this.thumbsSwiper = null;
  }

  connectedCallback() {
    const swiperSelector = this.getAttribute("main-swiper");
    const swiperEl = swiperSelector ? this.querySelector(swiperSelector) : null;

    if (!swiperEl || typeof Swiper === "undefined") return;

    const thumbsSelector = this.getAttribute("thumbs");
    const thumbsEl = thumbsSelector ? this.querySelector(thumbsSelector) : null;

    if (thumbsEl) {
      const thumbsOptions = {
        direction: this.getAttribute("thumbs-direction") || "horizontal",
        slidesPerView: this.numberAttr("thumbs-slides-per-view", 4),
        spaceBetween: this.numberAttr("thumbs-space-between", 10),
        watchSlidesProgress: this.hasAttribute("thumbs-watch-progress"),
        slideToClickedSlide: this.hasAttribute("thumbs-click-to-slide"),
      };

      const thumbsBreakpoints = this.getAttribute("thumbs-breakpoints");
      if (thumbsBreakpoints) {
        try {
          thumbsOptions.breakpoints = JSON.parse(thumbsBreakpoints);
        } catch (e) {
          console.warn("Invalid thumbs-breakpoints JSON", e);
        }
      }

      this.thumbsSwiper = new Swiper(thumbsEl, thumbsOptions);
    }

    const options = {
      slidesPerView: this.numberAttr("slides-per-view", 1),
      spaceBetween: this.numberAttr("space-between", 0),
      centeredSlides: this.hasAttribute("centered"),
      loop: this.hasAttribute("loop"),
      initialSlide: this.numberAttr("initial-slide", 0),
      slideToClickedSlide: this.hasAttribute("clicked-to-slide"),
      speed: this.numberAttr("speed", 300),
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
    };

    const nextSel = this.getAttribute("next");
    const prevSel = this.getAttribute("prev");

    if (nextSel && prevSel) {
      options.navigation = {
        nextEl: this.querySelector(nextSel),
        prevEl: this.querySelector(prevSel),
      };
    }

    const paginationSel = this.getAttribute("pagination");
    const paginationType = this.getAttribute("pagination-type");

    if (paginationSel) {
      options.pagination = {
        el: this.querySelector(paginationSel),
        clickable: true,
        type: paginationType || "bullets",
      };
    }

    const breakpoints = this.getAttribute("breakpoints");
    if (breakpoints) {
      try {
        options.breakpoints = JSON.parse(breakpoints);
      } catch (e) {
        console.warn("Invalid breakpoints JSON", e);
      }
    }

    if (this.thumbsSwiper) {
      options.thumbs = { swiper: this.thumbsSwiper };
    }

    this.mainSwiper = new Swiper(swiperEl, options);

    this.initCustomBullets();
  }

  initCustomBullets() {
    if (!this.mainSwiper) return;

    const bulletWrap = this.querySelector(".custom-pagination-bullet");
    if (!bulletWrap) return;

    bulletWrap.innerHTML = "";

    const totalSlides = this.mainSwiper.slides.length - 1;

    for (let i = 0; i < totalSlides; i++) {
      const bullet = document.createElement("button");
      bullet.type = "button";
      bullet.className = "custom-bullet";
      bullet.setAttribute("aria-label", `Go to slide ${i + 1}`);

      bullet.addEventListener("click", () => {
        this.mainSwiper.slideTo(i);
      });

      bulletWrap.appendChild(bullet);
    }

    const updateActiveBullet = () => {
      const bullets = bulletWrap.querySelectorAll(".custom-bullet");
      bullets.forEach((bullet, index) => {
        bullet.classList.toggle(
          "is-active",
          index === this.mainSwiper.realIndex,
        );
      });
    };

    updateActiveBullet();
    this.mainSwiper.on("slideChange", updateActiveBullet);
  }

  disconnectedCallback() {
    if (this.mainSwiper) this.mainSwiper.destroy(true, true);
    if (this.thumbsSwiper) this.thumbsSwiper.destroy(true, true);
  }

  numberAttr(name, fallback) {
    const val = this.getAttribute(name);
    return val !== null ? Number(val) : fallback;
  }
}

customElements.define("swiper-slide", SwiperSlide);
